import * as React from "react";
import { ChatThreadSwitcher } from "../chat/ChatThreadSwitcher";
import { SidepaneItem } from "live-lesson/shared/feature-call-ui-react";


interface ChatThreadSwitcherSidePaneItemProps {
    isOpen: boolean;
    close?: () => void;
    isMobile: boolean;
    activatedChatTopic?: string;
}


export const ChatThreadSwitcherSidePaneItem = (props: ChatThreadSwitcherSidePaneItemProps): JSX.Element => {
    const { isOpen, close, activatedChatTopic } = props;
    return (
        <SidepaneItem
            isOpen={isOpen}
            close={close}
            headerText={activatedChatTopic}
            closeButtonText={'Schließen'}
        >
            <ChatThreadSwitcher isOpen={isOpen} />
        </SidepaneItem>
    );
};
